const currencyFormatter = new Intl.NumberFormat('en-AU', {style: 'currency', currency: 'AUD', minimumFractionDigits: 0, maximumFractionDigits: 0});

export default currencyFormatter;
